import React, { useContext } from 'react'
import ReactModal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { ModalContext } from './Modals'

export interface IModalProps {
	contentLabel: String
	children: any
	isOpen?: boolean
	isLoading?: boolean
	contentLabelIcon?: any
	onClose?: Function
	onModalClose?: Function
	onSubmit?: Function
	submitDisabled?: boolean
	showFooter?: boolean
	closeEnabled?: boolean
	settings?: Object
	style?: Object
	headerClass?: String
	contentClass?: String
}

ReactModal.setAppElement('body')

const btnDefaults = {
	btnText: 'save',
	btnClass: 'bg-green-500 text-white',
}

const modalDefaults = {
	showFooter: true,
	closeEnabled: true,
}

export default function Modal(props: IModalProps) {
	const {
		isOpen = true,
		isLoading = false,
		contentLabel,
		onSubmit,
		onClose,
		onModalClose,
		submitDisabled,
		contentLabelIcon,
		children,
		headerClass = 'bg-gray-100',
		contentClass = 'px-4',
		style = {},
	} = props
	const btnSettings = { ...btnDefaults, ...props.settings }
	const modalSettings = { ...modalDefaults, ...props }

	const modalHelper = useContext(ModalContext)

	const close = () => {
		if (onClose) {
			onClose()
		} else if (onModalClose) {
			onModalClose()
		} else if (modalHelper) {
			modalHelper.handler.close(modalHelper.modalId)
		} else {
			console.log('no close function defined')
		}
	}

	let customHeader
	let customFooter

	let mainChildren = React.Children.toArray(children)
	mainChildren.map((child: any) => {
		if (child.type == 'header') {
			customHeader = child
		}
		if (child.type == 'footer') {
			customFooter = child
		}
	})

	mainChildren = mainChildren.filter(
		(child: any) => !['header', 'footer'].includes(child.type)
	)

	return (
		<ReactModal
			isOpen={isOpen}
			shouldCloseOnOverlayClick={modalSettings.closeEnabled}
			shouldCloseOnEsc={modalSettings.closeEnabled}
			onRequestClose={() => close()}
			contentLabel={contentLabel}
			style={style}
		>
			{customHeader}
			{!customHeader && (
				<header
					className={
						'flex items-center border-b py-3 relative px-4 ' + headerClass
					}
				>
					<h2 className="text-xl font-semibold">
						{contentLabelIcon && (
							<FontAwesomeIcon className="mr-2" icon={contentLabelIcon} />
						)}
						{contentLabel}
					</h2>
					<button
						className="ml-auto absolute right-0 top-0 cursor-pointer outline-none focus:ring-0"
						type="button"
						disabled={!modalSettings.closeEnabled}
						onClick={() => close()}
					>
						<FontAwesomeIcon className="text-xl" icon={faTimes} />
					</button>
				</header>
			)}

			<div className={'ReactModal__Wrapper ' + contentClass}>
				{isLoading && <div className="py-3">...loading</div>}
				{!isLoading && mainChildren}
			</div>
			{!isLoading && (
				<>
					{customFooter}
					{!customFooter && modalSettings.showFooter && onSubmit && (
						<footer className="flex items-center border-t py-3 px-4 bg-white">
							<button
								className={btnSettings.btnClass}
								disabled={submitDisabled}
								onClick={(event) => onSubmit(event)}
							>
								{btnSettings.btnText}
							</button>
						</footer>
					)}
				</>
			)}
		</ReactModal>
	)
}
